import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { _className, LL_V_L, ModuleFE_Dialog, performAction, stopPropagation, ToastBuilder, TS_Dialog, TS_Input } from '@nu-art/thunderstorm-frontend/index';
import { Second } from '@nu-art/ts-common';
import { ICONS } from '@app/styles';
import { QDatePicker, QToastContent } from '../../../q-components/index.js';
import { ModuleFE_Reference } from '../../../../_entity.js';
export class Dialog_UpToDateEditor extends TS_Dialog {
    // ######################### Static #########################
    static show(onRefUpsertCallback, reference) {
        ModuleFE_Dialog.show({ content: _jsx(Dialog_UpToDateEditor, { onRefUpsertCallback: onRefUpsertCallback, reference: reference }), closeOverlayOnClick: () => true });
    }
    static defaultProps = {
        dialogId: 'dialog-up-to-date-editor',
    };
    // ######################### Life Cycle #########################
    deriveStateFromProps(nextProps, state) {
        state.data = this.state?.data || this.props.reference?.data || {
            name: '',
            lastUpdate: Date.now(),
            url: '',
        };
        return state;
    }
    // ######################### Logic #########################
    linkIsUpToDate = (link) => {
        return link.toLowerCase().includes('uptodate.com');
    };
    canBeSaved() {
        return this.linkIsUpToDate(this.state.data.url);
    }
    handleSave = async () => {
        await performAction(async () => {
            this.setState({ dialogIsBusy: true });
            try {
                const ref = this.props.reference || {
                    type: 'upToDate',
                };
                ref.data = this.state.data;
                const newRef = await ModuleFE_Reference.v1.upsert(ref).executeSync();
                this.props.onRefUpsertCallback(newRef, newRef);
                ModuleFE_Dialog.close();
            }
            catch (e) {
                this.logError(e);
            }
            finally {
                this.setState({ dialogIsBusy: false });
            }
        }, { type: 'notification', notificationLabels: 'Saving UpToDate Reference' });
    };
    // ######################### Render #########################
    renderLinkInput() {
        return _jsxs(LL_V_L, { className: 'match_width', children: [_jsx("span", { className: 'dialog__field-title', children: "Link" }), _jsx(TS_Input, { type: 'text', placeholder: 'Enter Link', value: this.state.data.url, tabIndex: 0, onKeyDown: (e) => {
                        if (!((e.ctrlKey || e.metaKey) && e.key === 'v')) {
                            stopPropagation(e);
                        }
                        if (e.key === 'Backspace') {
                            this.state.data.url = '';
                            this.forceUpdate();
                        }
                    }, onChange: link => {
                        if (!this.linkIsUpToDate(link)) {
                            new ToastBuilder().setDuration(6 * Second)
                                .setContent(QToastContent({ iconKey: 'x', content: 'Link is not an UpToDate link', toastType: 'error' }))
                                .show();
                            this.forceUpdate();
                        }
                        else {
                            const cleanLink = link.split('?')[0];
                            const split = cleanLink.split('/');
                            this.state.data.url = cleanLink;
                            this.state.data.name = split[split.length - 1];
                            this.forceUpdate();
                        }
                    } })] });
    }
    renderName() {
        return _jsxs(LL_V_L, { className: 'match_width', children: [_jsx("span", { className: 'dialog__field-title', children: "Name" }), _jsx(TS_Input, { type: 'text', value: this.state.data.name, onChange: (value) => {
                        this.state.data.name = value;
                        this.forceUpdate();
                    } })] });
    }
    renderDate() {
        return _jsxs(LL_V_L, { children: [_jsx("span", { className: 'dialog__field-title', children: "Last Updated" }), _jsx(QDatePicker, { selected: new Date(this.state.data.lastUpdate), onChange: (value) => {
                        this.state.data.lastUpdate = value;
                        this.forceUpdate();
                    } })] });
    }
    renderHeader = () => {
        return _jsxs(_Fragment, { children: [_jsxs("div", { className: 'header__title', children: [this.props.reference ? 'Edit' : 'Add', " Up To Date"] }), _jsx("div", { className: 'header__buttons', children: _jsx(ICONS.x.component, { className: "exit_icon", onClick: () => ModuleFE_Dialog.close() }) })] });
    };
    renderBody = () => {
        return _jsxs(_Fragment, { children: [this.renderLinkInput(), this.renderName(), this.renderDate()] });
    };
    buttons = () => {
        return {
            right: [
                {
                    content: 'Cancel',
                    onClick: () => ModuleFE_Dialog.close(),
                },
                {
                    content: 'Save',
                    className: _className(this.canBeSaved() ? 'desired-action-button' : ''),
                    disabled: !this.canBeSaved() || this.state.dialogIsBusy,
                    onClick: this.handleSave,
                }
            ]
        };
    };
}
//# sourceMappingURL=Dialog_UpToDateEditor.js.map